import { Heading, HeadingProps } from '@qga/roo-ui/components';
import { useBookingList } from '../BookingListProvider';

type StylingProps = HeadingProps;

const BookingListHeading = (props: StylingProps) => {
  const { bookingListLabel } = useBookingList();

  return (
    <Heading data-testid="booking-list-heading" fontSize="28px" fontWeight="normal" mb={0} {...props}>
      {bookingListLabel}
    </Heading>
  );
};

export default BookingListHeading;
